import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setAuth, errMsg } from "../lib/api";

/* Custom Google OAuth callback — Google redirects here with ?code=...
   REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
   THIS BREAKS THE AUTH. redirect_uri is always window.location.origin based. */
export default function GoogleCallback() {
  const nav = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) {
      toast.error("Google sign-in was cancelled");
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/exchange", {
          code,
          redirect_uri: window.location.origin + "/auth/google",
        });
        setAuth(data.token, data.user);
        toast.success(data.new_user ? "Welcome! Your free trial is ready." : "Welcome back!");
        nav(data.user.role === "admin" ? "/admin" : "/seller/auto-listing", { replace: true });
      } catch (e) {
        toast.error(errMsg(e, "Google sign-in failed"));
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#070A14] grid place-items-center text-slate-400 text-sm" data-testid="google-callback-loading">
      Signing you in with Google…
    </div>
  );
}
